import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Auth } from "../models/auth.model";
import { CentroDistribuicao } from "../models/centro-distribuicao.model";
import { MailCheckout } from "../models/mail-checkout";
import { Retorno } from "../models/Retorno.model";
import { PermiteReenvioSolicitacao } from "../models/PermiteReenvioSolicitacao.model";
import { PreCheckoutStatus } from "../models/pre-checkout-status.model";
import { SMS } from "../models/sms.model";
import { StatusMotorista } from "../models/status-motorista.model";
import { Transportadora } from "../models/transportadora.model";
import { Veiculo } from "../models/veiculo.model";
import { Viagem } from "../models/viagem.model";
import { PreCheckoutQuery } from "../state/pre-checkout.query";
import { RetornoChecklist } from "../models/retorno-checklist.model";

const CLIENTE_ID = 29610; //Cliente GPA

@Injectable({
    providedIn: 'root'
})
export class PreCheckoutService{
    hash: string;
    constructor(
        protected httpClient: HttpClient,
        private preCheckoutQuery: PreCheckoutQuery
    ){
        this.preCheckoutQuery.hash$.subscribe((hash)=>{
            this.hash = hash;
        });
    }
    
    getMotorista(cpf: number)
    {
        return this.httpClient.get<StatusMotorista>(`${environment.address}api/v4/viagem/PreCheckout/consultarmotorista?cpf=${cpf}`);
    }

    getCds(origem: boolean = false, descricao: string = null)
    {
        let params = new HttpParams();
        params = params.append("cliente_ids", CLIENTE_ID.toString());
        params = params.append("origem", origem.toString());

        if(descricao)
            params = params.append("descricao", descricao);

        return this.httpClient.get<CentroDistribuicao>(`${environment.address}api/v4/viagem/Locais`, {params: params});
    }

    getTranspotadoras(cnpj: string = null)
    {
        let params = new HttpParams();
        params = params.append("cnpj", cnpj);

        return this.httpClient.get<Transportadora>(`${environment.address}api/v4/viagem/PreCheckout/gettransportadoras`, {params: params});
    }

    getVeiculo(placa: string = null, cdOrigem: number, tipo: string = null)
    {
        let params = new HttpParams();
        params = params.append("placa", placa);
        params = params.append("cdOrigem", cdOrigem.toString());

        if(tipo)
            params = params.append("tipo", tipo);

        return this.httpClient.get<Veiculo>(`${environment.address}api/v4/viagem/PreCheckout/getveiculobyplaca`, {params: params});
    }

    getChecklist(placa: string = null, cpf: string = null)
    {
        let params = new HttpParams();
        params = params.append("placa", placa);
        params = params.append("cpf", cpf);

        return this.httpClient.get<RetornoChecklist>(`${environment.address}api/v4/viagem/PreCheckout/getchecklist`, {params: params});
    }

    getViagemByCpfOrigem(cpf: string, cdOrigem: number, rota: string = null)
    {
        let params = new HttpParams();
        params = params.append("cpf", cpf);
        params = params.append("cdOrigem", cdOrigem.toString());

        if(rota)
            params = params.append("rota", rota);

        return this.httpClient.get<Viagem>(`${environment.address}api/v4/viagem/PreCheckout/getviagembycpforigem`, {params: params});
    }

    getViagemBySm(sm: number)
    {
        return this.httpClient.get<Viagem>(`${environment.address}api/v4/viagem/PreCheckout/getviagembysm?sm=${sm}`);
    }

    GetSinalVeiculo(sm: number)
    {
        return this.httpClient.get<boolean>(`${environment.address}api/v4/viagem/PreCheckout/getsinalveiculo?sm=${sm}`);
    }

    GetSensorEngate(sm: number)
    {
        return this.httpClient.get<boolean>(`${environment.address}api/v4/viagem/PreCheckout/getsensorengate?sm=${sm}`);
    }

    GetBauFechado(sm: number)
    {
        return this.httpClient.get<boolean>(`${environment.address}api/v4/viagem/PreCheckout/getbaufechado?sm=${sm}`);
    }

    GetAlvoOrigem(sm: number)
    {
        return this.httpClient.get<boolean>(`${environment.address}api/v4/viagem/PreCheckout/getalvoorigem?sm=${sm}`);
    }

    GetMacroInicioViagem(sm: number)
    {
        return this.httpClient.get<boolean>(`${environment.address}api/v4/viagem/PreCheckout/getmacroinicioviagem?sm=${sm}`);
    }

    CreateMailCheckout(mailCheckout: MailCheckout)
    {
        mailCheckout.hash = this.hash;
        return this.httpClient.post<number>(`${environment.address}api/v4/viagem/PreCheckout/createmailcheckout`, mailCheckout);
    }

    PermiteReenvioSolicitacao(mailCheckout: MailCheckout)
    {
        return this.httpClient.post<PermiteReenvioSolicitacao>(`${environment.address}api/v4/viagem/PreCheckout/permitereenviomail`, mailCheckout);
    }

    sendSMS(celular: string, message: string)
    {
        let params = {
            "codigo_outbox": 0,
            "contrato": "FAST",
            "fone_para": celular,
            "mensagem": message,
            "operador": "VONEX",
            "sistema_origem": "Pré-checkout",
            "codigo_cliente": 29610, //Código do cliente GPA
            "codigo_usuario": 0,
            "codigo_externo": null
        };

        return this.httpClient.post<SMS>(`${environment.address}api/v4/viagem/PreCheckout/sendsms`, params);
    }

    sendMail(subject: string, content: string, to: string, cc: string = null)
    {
        let params = {
            "subject": subject,
            "content": content,
            "to": to
        };

        //return this.httpClient.post<Mail>("https://api.buonny.com.br/api/mailer/mailer", params);
        return this.httpClient.get<Retorno>(`${environment.address}api/v4/viagem/PreCheckout/sendmail`, {params: params});
    }

    updateCpf(sm: number, cpf: string)
    {
        return this.httpClient.post<Retorno>(`${environment.address}api/v4/viagem/PreCheckout/atualizacpfsm?sm=${sm}&cpf=${cpf}`, null);
    }

    updatePlaca(sm: number, placas: Array<string>)
    {
        return this.httpClient.post<Retorno>(`${environment.address}api/v4/viagem/PreCheckout/atualizaplacassm?sm=${sm}`, placas);
    }

    updatePhone(cpf: string, telefone: string)
    {
        return this.httpClient.post(`${environment.address}api/v4/viagem/PreCheckout/atualizatelefone?cpf=${cpf}&telefone=${telefone}&hash=${this.hash}`, null);
    }

    bloquearMotorista(cpf: string)
    {
        return this.httpClient.post(`${environment.address}api/v4/viagem/PreCheckout/bloquearmotorista`, {cpf:cpf, hash:this.hash});
    }

    createEvent(checkout: PreCheckoutStatus)
    {
        return this.httpClient.post(`${environment.address}api/v4/viagem/PreCheckout/createeventprecheckout?hash=${this.hash}`, checkout);
    }

    Authentication()
    {
        let auth = {
            "username": environment.userAuth,
            "password": environment.passAuth
        }
        return this.httpClient.post<any>(`${environment.address}api/v4/viagem/Auth`, auth);
    }
}